import React from "react";
import EditLancamento from "../../EditarLancamento";
import { ModalEditarLoteLivroRazao } from "../ModalEditarLoteLivroRazao";

export default function RazaoModals({
    editVisible,
    setEditVisible,
    editingId,
    dataInicio,
    contasContabeis,
    handlePesquisar,
    onSaved,
    editLoteVisible,
    setEditLoteVisible,
    selectedLancamentos,
    setSelectedLancamentos,
    zIndex,
    onFocus,
    editLoteZIndex,
    onFocusLote
}) {
    return (
        <>
            <EditLancamento
                visible={editVisible}
                lancamentoId={editingId}
                competencia={dataInicio ? dataInicio.format("MM/YYYY") : null}
                contasContabeis={contasContabeis}
                onSaved={() => {
                    setEditVisible(false);
                    handlePesquisar();
                    onSaved?.();
                }}
                onClose={() => setEditVisible(false)}
                zIndex={zIndex}
                onFocus={onFocus}
                modalKey="editLancamentoRazao"
                getContainer={() => document.body}
            />

            <ModalEditarLoteLivroRazao
                open={editLoteVisible}
                lancamentos={selectedLancamentos}
                contasContabeis={contasContabeis}
                onClose={() => setEditLoteVisible(false)}
                onSaved={() => {
                    setEditLoteVisible(false);
                    setSelectedLancamentos([]);
                    handlePesquisar();
                    onSaved?.();
                }}
                zIndex={editLoteZIndex}
                onFocus={onFocusLote}
                getContainer={() => document.body}
            />
        </>
    );
}
